import { Outlet } from "react-router-dom";

import Header from "./header/Header";
import Footer from "./footer/Footer";

const MainLayout = () => {
  return (
    <>
      <Header />
      <main className="container min-h-[calc(100vh-392px)] sm:min-h-[calc(100vh-423px)] px-4 sm:px-8 mx-auto mt-[100px] sm:mt-[130px]">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default MainLayout;
